
import {IRiskInfo} from "./risk-info.interface";
import {consts} from '../common/modals/consts';

export class RiskInfo implements IRiskInfo{
  id: string;
  index: number;
  name: string;
  description: string;
  examples: string;
  examplesSummary: string;
  operativeTypeId: string;
  isSelected: boolean;

  constructor(iRiskInfo: IRiskInfo = null){
    this.id = iRiskInfo?.id ??  consts.emptyGuid;
    this.index = iRiskInfo?.index ?? 0;
    this.name = iRiskInfo?.name ?? "";
    this.description = iRiskInfo?.description ?? "";
    this.examples = iRiskInfo?.examples ?? "";
    this.examplesSummary = iRiskInfo?.examplesSummary ?? "";
    this.operativeTypeId = iRiskInfo?.operativeTypeId ?? "";
    this.isSelected = iRiskInfo?.isSelected ?? false;
  }



}
